<template>
  <div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--9">
			<div class="row">
				<div class="col">
					<div class="card shadow">
						<div class="card-header bg-transparent">
							<div class="d-flex justify-content-between">
								<h3>Prospectos</h3>
                <base-button 
                  v-if="userPermission()"
                  @click="modalNewProspect = true" >
                  Nuevo Prospecto
                </base-button>
							</div>
						</div>
            <ag-grid-vue
              v-bind="agProspects"
              @cellEditRequest="onCellEditRequest"
              style="height: 70vh;"
              class="ag-theme-alpine mb-4"
            />
					</div>
				</div>
			</div>
		</div>

    <!-- Modal New Prospect -->
    <b-modal
      v-model="modalNewProspect"
      id="modalNewProspect"
      size="lg"
      bodyClass="p-0"
      hide-footer
      hide-header
    >
      <NewProspect
        v-if="modalNewProspect"
        @success="getProspects()"
        @close="modalNewProspect = false"
      />
    </b-modal>
  </div>
</template>
<script>
/* eslint-disable vue/no-unused-components */

import NewProspect from './NewProspect.vue';
import { getAuth } from "firebase/auth";
import { AG_GRID_LOCALE_ES } from '@ag-grid-community/locale';
import EmptySection from "@/components/EmptySection.vue";
import BaseLoader from "@/components/BaseLoader.vue";
import { AgGridVue } from "ag-grid-vue";
import { getFirestore, collection, getDocs, doc, setDoc  } from "firebase/firestore";
import states from "@/data/states";
import FilterDate from "@/components/AgGrid/Filters/FilterDate.vue";
import moment from 'moment';
import AgGrid from "@/mixins/AgGrid.js";
import axios from "axios";
export default {
  mixins: [AgGrid],
  components: {
    NewProspect,
    EmptySection,
    AgGridVue,
    BaseLoader,
    agDateInput: FilterDate,
  },
  data() {
    return {
      user: null,
      modalNewProspect: false,
      salesPersonOptions: null,
      agProspects: {
        rowData: null,
        columnDefs: [
          {
            headerName: "Empresa",
            field: "company",
            filter: "agTextColumnFilter",
          },
          {
            headerName: "Nombre",
            field: "name",
            filter: "agTextColumnFilter",
          },
          {
            headerName: "Teléfono",
            field: "phone",
            filter: "agTextColumnFilter",
          },
          {
            headerName: "Estado",
            field: "state",
            valueFormatter: this.stateFormatter,
            filter: "agSetColumnFilter",
            filterParams: {
              values: states.map((x) => x.code),  
              valueFormatter: this.stateFormatter,
              defaultToNothingSelected: true,
              applyMiniFilterWhileTyping: true,
            },

          },
          {
            headerName: "Ciudad",
            field: "city",
            filter: "agTextColumnFilter",
          },
          {
            headerName: "Correo",
            field: "email",
            filter: "agTextColumnFilter",
          },
          {
            headerName: "Ramo",
            field: "sector",
            filter: "agSetColumnFilter",
            filterParams: {
              values: [
                "Distribuidor",
                "Fabricante",
                "No identificado"
              ],
              defaultToNothingSelected: true,
              applyMiniFilterWhileTyping: true,
            },
          },
          {
            headerName: "Fecha",
            field: "date",
            filter: "agDateColumnFilter",
            filterParams: {
              comparator: this.dateFilterComparator,
            },
          },
          {
            headerName: "Asignado a",
            field: "assigned",
            filter: "agSetColumnFilter",
            filterParams: {
              values: ({success}) => success(this.salesPersonOptions.map((x) => x.SalesEmployeeCode)),
              defaultToNothingSelected: true,
              applyMiniFilterWhileTyping: true,
              valueFormatter: ({value}) => {
                const salesP = this.salesPersonOptions.find((x) => x.SalesEmployeeCode === value);
                return salesP ? salesP.SalesEmployeeName : "";
              }
            },
            tooltipValueGetter: ({value}) => value === null && this.userPermission() ? 'Doble click para editar' : null,
            editable: ({data}) => data.assigned === null && this.userPermission(), 
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
              values: () => this.salesPersonOptions.map((x) => x.SalesEmployeeCode),
            },
            valueFormatter: ({value}) => {
              const salesP = this.salesPersonOptions.find((x) => x.SalesEmployeeCode === value);
              return salesP ? salesP.SalesEmployeeName : "Sin asignar";
            }
          },
        ],
        defaultColDef: {
          suppressHeaderMenuButton: true,
          floatingFilter: true,
        },
        autoSizeStrategy: {
          type: 'fitGridWidth',
          defaultMinWidth: 100,
        },
        pagination: true,
        paginationPageSize: 1000,
        paginationPageSizeSelector: [100, 500, 1000, 2000],
        loadingOverlayComponent: "BaseLoader",
        noRowsOverlayComponent: "EmptySection",
        suppressCellFocus: true,
        enableCellTextSelection: true,
        alwaysShowVerticalScroll: true,
        localeText: AG_GRID_LOCALE_ES,
        readOnlyEdit:true,
        defaultCsvExportParams: {
          processCellCallback: this.exportCellCallback,
        },
        defaultExcelExportParams: {
          processCellCallback: this.exportCellCallback,
        },
      },
    }
  },  
  methods: {
    userPermission(){
      return [
        'federicoflores@canplast.com.mx',
        'bereniceterrazas@canplast.com.mx',
        'alfredoreyes@canplast.com.mx',
        'leslysifuentes@canplast.com.mx',
      ].includes(this.user.email)
    },
    getProspects() {
      const db = getFirestore();
      const coll = collection(db, "prospects")
      getDocs(coll).then((snapshot) => {
        if (!snapshot.empty) {
          this.agProspects.rowData = snapshot.docs
          .map((doc) => {
            return {
              ...doc.data(),
              id: doc.id,
              date:moment.unix(doc.data().datetime.seconds).format('YYYY-MM-DD')
            };
          })
          .sort((a, b) => {
            return (a.assigned === null ? -1 : 0) - (b.assigned === null ? -1 : 0)
          });
        } else {
          this.agProspects.rowData = [];
        }
      });
    },
    stateFormatter({value}){
      const state = states.find((state) => state.code === value);
      return state ? state.name : value;
    },
    exportCellCallback({column, value}){
      if (column.getColId() === 'assigned') {
        const salesP = this.salesPersonOptions
          ? this.salesPersonOptions.find((x) => x.SalesEmployeeCode === value)
          : null;
        return salesP ? salesP.SalesEmployeeName : "Sin asignar";
      }
      return value;
    },
    onCellEditRequest({newValue, data, column}){
      if(column.colId === 'assigned'){
        const salesP = this.salesPersonOptions.find((x) => x.SalesEmployeeCode === newValue);
        this.$swal({
          title: `¿Asignar a ${salesP.SalesEmployeeName} como vendedor/a?`,
          text : `${data.company} - ${data.name}`,
          icon: 'question',
          confirmButtonText: "Si, asignar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
        }).then((result) => {
          if (result.isConfirmed) {
            const db = getFirestore();
            const coll = collection(db, "prospects");
            const docRef = doc(coll, data.id);
            setDoc(docRef, {[column.colId]: newValue}, { merge: true })
            .then(() => {
              this.getProspects();
              this.$swal({
                title: "Prospecto actualizado",
                text: `El Prospecto ${data.company} ha sido actualizado correctamente`,
                icon: "success",
              });
            }).catch((error) => {
              console.error("Error", error);
              this.$swal({
                title: "Error al actualizar prospecto",
                text: `Ocurrió un error al actualizar el prospecto ${data.company} - ${data.name}`,
                icon: "error",
              });
            });
          }
        });
      }
    } 
  },
  created(){
    const auth = getAuth();
    this.user = auth.currentUser;
    axios
      .get(`/api/sales_persons`)
      .then((response) => {
        this.salesPersonOptions = response.data.value;
        this.getProspects();
      })
      .catch((error) => {
        console.error(error);
      });
    
  },
}
</script>
<style scoped>
</style>